import { ISimpleSelectItem } from '../../components/select/SimpleSelect';
import { DocumentCategory } from 'src/types/enums';

export const DOCUMENT_CATEGORY_VALUES: ISimpleSelectItem[] = Object.values(DocumentCategory).map((v) => {
  return {
    name: v,
    key: v,
  };
});
